import { User } from 'oidc-client';

export const setAccessTokenToLS = (access_token: string) => {
  localStorage.setItem('access_token', access_token);
};

export const getAccessTokenFromLS = () => {
  return localStorage.getItem('access_token') || '';
};

export const clearLS = () => {
  // localStorage.removeItem('access_token');
  // localStorage.removeItem('profile');
  // localStorage.removeItem('isAdmin');

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('oidc.') || ['access_token', 'profile', 'isAdmin', 'returnUrl'].includes(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const getProfileFromLS = () => {
  const result = localStorage.getItem('profile');
  return result ? JSON.parse(result) : null;
};

export const setProfileToLS = (profile: User) => {
  try {
    setAccessTokenToLS(profile.access_token);
    localStorage.setItem('profile', JSON.stringify(profile));
  } catch (e) {
    console.error('Lỗi ghi profile vào localStorage:', e);
    // Nếu lưu lỗi thì clear luôn localStorage để tránh vòng lặp
    clearLS();
  }
};
